"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.articleViewMetricSchema = exports.articleActionSchema = exports.listArticlesResponseSchema = exports.listArticlesQuerySchema = exports.aiRefreshArticleRequestSchema = exports.aiGenerateArticleRequestSchema = exports.publishArticleRequestSchema = exports.updateArticleRequestSchema = exports.createArticleRequestSchema = exports.articleListItemSchema = exports.articleBaseSchema = exports.articleImageSchema = exports.articleReadtimeSchema = exports.articleSeoSchema = exports.blogTagSchema = exports.blogCategorySchema = exports.articleSourceSchema = exports.articleOrderDirectionSchema = exports.articleSortFieldSchema = exports.articleStatusSchema = void 0;
const zod_1 = require("zod");
exports.articleStatusSchema = zod_1.z.enum([
    "DRAFT",
    "SCHEDULED",
    "PUBLISHED",
    "UNPUBLISHED",
    "ARCHIVED",
]);
exports.articleSortFieldSchema = zod_1.z.enum([
    "createdAt",
    "updatedAt",
    "publishedAt",
    "viewCount",
]);
exports.articleOrderDirectionSchema = zod_1.z.enum(["asc", "desc"]);
exports.articleSourceSchema = zod_1.z.enum([
    "admin",
    "import",
    "ai",
    "external",
]);
exports.blogCategorySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    slug: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable().optional(),
    color: zod_1.z.string().nullable().optional(),
    isActive: zod_1.z.boolean().default(true),
    sortOrder: zod_1.z.number().int().nonnegative().default(0),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable().optional(),
    createdAt: zod_1.z.string().datetime().optional(),
    updatedAt: zod_1.z.string().datetime().optional(),
})
    .strict();
exports.blogTagSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    slug: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable().optional(),
    color: zod_1.z.string().nullable().optional(),
    usageCount: zod_1.z.number().int().nonnegative().optional(),
    isActive: zod_1.z.boolean().default(true),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable().optional(),
    createdAt: zod_1.z.string().datetime().optional(),
    updatedAt: zod_1.z.string().datetime().optional(),
})
    .strict();
exports.articleSeoSchema = zod_1.z
    .object({
    title: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    keywords: zod_1.z.array(zod_1.z.string()).default([]),
    canonicalUrl: zod_1.z.string().url().nullable().optional(),
    noIndex: zod_1.z.boolean().default(false),
    noFollow: zod_1.z.boolean().default(false),
    social: zod_1.z
        .object({
        title: zod_1.z.string().optional(),
        description: zod_1.z.string().optional(),
        imageUrl: zod_1.z.string().url().optional(),
    })
        .strict()
        .default({}),
})
    .strict();
const DEFAULT_ARTICLE_SEO = {
    keywords: [],
    noIndex: false,
    noFollow: false,
    social: {},
};
exports.articleReadtimeSchema = zod_1.z
    .object({
    readingMinutes: zod_1.z.number().nonnegative().default(0),
    sourceWordCount: zod_1.z.number().nonnegative().default(0),
    readingDifficulty: zod_1.z.enum(["easy", "medium", "advanced"]).default("easy"),
})
    .strict();
const DEFAULT_ARTICLE_READTIME = {
    readingMinutes: 0,
    sourceWordCount: 0,
    readingDifficulty: "easy",
};
exports.articleImageSchema = zod_1.z
    .object({
    url: zod_1.z.string().url(),
    alt: zod_1.z.string(),
    caption: zod_1.z.string().nullable().optional(),
    width: zod_1.z.number().int().positive().optional(),
    height: zod_1.z.number().int().positive().optional(),
})
    .strict();
exports.articleBaseSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    slug: zod_1.z.string(),
    title: zod_1.z.string(),
    status: exports.articleStatusSchema,
    excerpt: zod_1.z.string(),
    content: zod_1.z.string(),
    contentFormat: zod_1.z.enum(["markdown", "html", "json"]).default("html"),
    source: exports.articleSourceSchema.default("admin"),
    categoryId: zod_1.z.string().nullable().optional(),
    featuredImage: exports.articleImageSchema.nullable().default(null),
    heroImageUrl: zod_1.z.string().url().nullable().optional(),
    heroImageAlt: zod_1.z.string().nullable().optional(),
    adWidgetHtml: zod_1.z.string().nullable().optional(),
    keywords: zod_1.z.array(zod_1.z.string()).default([]),
    seo: exports.articleSeoSchema.default(DEFAULT_ARTICLE_SEO),
    readtime: exports.articleReadtimeSchema.default(DEFAULT_ARTICLE_READTIME),
    isPinned: zod_1.z.boolean().default(false),
    isAiGenerated: zod_1.z.boolean().default(false),
    aiPrompt: zod_1.z.string().nullable().optional(),
    publishedAt: zod_1.z.string().datetime().nullable().optional(),
    scheduledFor: zod_1.z.string().datetime().nullable().optional(),
    unpublishAt: zod_1.z.string().datetime().nullable().optional(),
    tagIds: zod_1.z.array(zod_1.z.string()).default([]),
    tags: zod_1.z.array(exports.blogTagSchema).default([]),
    category: exports.blogCategorySchema.nullable().optional(),
    createdByUserId: zod_1.z.string().nullable().optional(),
    updatedByUserId: zod_1.z.string().nullable().optional(),
    viewCount: zod_1.z.number().int().nonnegative().default(0),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
})
    .strict();
exports.articleListItemSchema = exports.articleBaseSchema
    .omit({
    content: true,
    contentFormat: true,
    tagIds: true,
    tags: true,
})
    .extend({
    categoryName: zod_1.z.string().nullable().optional(),
    tagNames: zod_1.z.array(zod_1.z.string()).default([]),
    tags: zod_1.z.array(exports.blogTagSchema).default([]),
})
    .strict();
exports.createArticleRequestSchema = zod_1.z
    .object({
    slug: zod_1.z.string().optional(),
    title: zod_1.z.string(),
    status: exports.articleStatusSchema.default("DRAFT"),
    excerpt: zod_1.z.string().max(400).default(""),
    content: zod_1.z.string(),
    contentFormat: zod_1.z.enum(["markdown", "html", "json"]).default("html"),
    source: exports.articleSourceSchema.default("admin"),
    categoryId: zod_1.z.string().nullable().optional(),
    featuredImage: exports.articleImageSchema.nullable().default(null),
    heroImageUrl: zod_1.z.string().url().nullable().optional(),
    heroImageAlt: zod_1.z.string().nullable().optional(),
    adWidgetHtml: zod_1.z.string().nullable().optional(),
    keywords: zod_1.z.array(zod_1.z.string()).default([]),
    seo: exports.articleSeoSchema.default(DEFAULT_ARTICLE_SEO),
    readtime: exports.articleReadtimeSchema.default(DEFAULT_ARTICLE_READTIME),
    isPinned: zod_1.z.boolean().default(false),
    isAiGenerated: zod_1.z.boolean().default(false),
    aiPrompt: zod_1.z.string().nullable().optional(),
    publishedAt: zod_1.z.string().datetime().nullable().optional(),
    scheduledFor: zod_1.z.string().datetime().nullable().optional(),
    unpublishAt: zod_1.z.string().datetime().nullable().optional(),
    tagIds: zod_1.z.array(zod_1.z.string()).default([]),
    adImageUrl: zod_1.z.string().url().nullable().optional(),
    adImageAlt: zod_1.z.string().nullable().optional(),
})
    .strict();
exports.updateArticleRequestSchema = exports.createArticleRequestSchema
    .partial()
    .extend({
    id: zod_1.z.string(),
})
    .strict();
exports.publishArticleRequestSchema = zod_1.z
    .object({
    status: zod_1.z.enum(["PUBLISHED", "UNPUBLISHED", "SCHEDULED"]),
    publishedAt: zod_1.z.string().datetime().nullable().optional(),
    scheduledFor: zod_1.z.string().datetime().nullable().optional(),
    unpublishAt: zod_1.z.string().datetime().nullable().optional(),
})
    .strict();
exports.aiGenerateArticleRequestSchema = zod_1.z
    .object({
    title: zod_1.z.string(),
    preferredTone: zod_1.z.enum(["informative", "marketing", "technical"]).default("informative"),
    targetAudience: zod_1.z.string().optional(),
    expectedWordCount: zod_1.z.number().int().min(500).max(1200).default(900),
    includeCallToAction: zod_1.z.boolean().default(true),
    categoryHint: zod_1.z.string().optional(),
    primaryKeyword: zod_1.z.string().min(2).max(120).optional(),
    secondaryKeywords: zod_1.z.array(zod_1.z.string().min(2).max(120)).max(12).default([]),
    tagHints: zod_1.z.array(zod_1.z.string()).default([]),
})
    .strict();
exports.aiRefreshArticleRequestSchema = exports.aiGenerateArticleRequestSchema.extend({
    articleId: zod_1.z.string(),
    regenerateSeo: zod_1.z.boolean().default(true),
    regenerateImagePlaceholders: zod_1.z.boolean().default(true),
    regenerateTags: zod_1.z.boolean().default(true),
}).strict();
exports.listArticlesQuerySchema = zod_1.z
    .object({
    status: exports.articleStatusSchema.optional(),
    categoryId: zod_1.z.string().optional(),
    tagId: zod_1.z.string().optional(),
    q: zod_1.z.string().optional(),
    page: zod_1.z.number().int().min(1).default(1),
    limit: zod_1.z.number().int().min(1).max(100).default(20),
    sortBy: exports.articleSortFieldSchema.default("publishedAt"),
    order: exports.articleOrderDirectionSchema.default("desc"),
    includeUnpublished: zod_1.z.boolean().default(false),
})
    .strict();
exports.listArticlesResponseSchema = zod_1.z
    .object({
    data: zod_1.z.array(exports.articleListItemSchema),
    total: zod_1.z.number().int().nonnegative(),
    page: zod_1.z.number().int().positive(),
    limit: zod_1.z.number().int().positive(),
    totalPages: zod_1.z.number().int().nonnegative(),
})
    .strict();
exports.articleActionSchema = zod_1.z.enum([
    "edit",
    "delete",
    "unpublish",
    "ai-refresh",
    "publish",
]);
exports.articleViewMetricSchema = zod_1.z
    .object({
    articleId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    periodFrom: zod_1.z.string().datetime(),
    periodTo: zod_1.z.string().datetime(),
    viewCount: zod_1.z.number().int().nonnegative(),
    uniqueVisitors: zod_1.z.number().int().nonnegative(),
    topReferralDomain: zod_1.z.string().nullable().optional(),
    topCountries: zod_1.z
        .array(zod_1.z.object({
        country: zod_1.z.string(),
        views: zod_1.z.number().int().nonnegative(),
    }))
        .default([]),
})
    .strict();
